/**
 * Tenant config — detecta si el frontend se está sirviendo bajo `/met`
 * (POC cliente MET — backend de energía) o en la raíz (QIA por defecto).
 *
 * La detección es runtime sobre window.location, así el mismo bundle
 * sirve ambos entornos sin builds separados.
 */

const isMet =
  typeof window !== 'undefined' &&
  window.location.pathname.startsWith('/met');

export const TENANT = isMet ? 'met' : 'qia';

// basename para <BrowserRouter> — sin slash final
export const TENANT_BASENAME = isMet ? '/met' : '/';

// prefijo que se inyecta entre API_BASE_URL y /api/v1
export const API_PREFIX = isMet ? '/met' : '';

